import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import MenuSection from './components/MenuSection';
import GallerySection from './components/GallerySection';
import ReservationSection from './components/ReservationSection';
import ReviewsSection from './components/ReviewsSection';
import LocationSection from './components/LocationSection';
import AwardsSection from './components/AwardsSection';
import Footer from './components/Footer';
import AdminDashboard from './components/AdminDashboard';
import { Toaster } from './components/ui/sonner';
import './App.css';

function HomePage() {
  return (
    <LanguageProvider>
      <div className="bg-[#FBF9F6] min-h-screen">
        <Navigation />
        <main>
          <Hero />
          <About />
          <MenuSection />
          <GallerySection />
          <ReservationSection />
          <ReviewsSection />
          <AwardsSection />
          <LocationSection />
        </main>
        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
